import queryString from 'query-string';

import { type IElectionApplicationLinksData } from '@/interface/IElection';
import { type IElectionObserverLinksData, type Organisation, type VolunteerRole } from '@/interface/IObserver';

// Derives the volunteer role from an application URL's query string. Agent is
// the default; observer is signalled either by an explicit `role=observer` or
// by the presence of a partner GUID param. The exact param names are a backend
// contract assumption (see docs/PRD-observer-role.md) — kept permissive here so
// either `partner` or `PartnerGuid` resolves correctly.
export const resolveRoleFromQuery = (search: string): VolunteerRole => {
	const parsed = queryString.parse(search);
	const partner = parsed.observer;
	if (typeof partner === 'string' && partner.length > 0) {
		return 'observer';
	}
	return 'agent';
};

// Adapts a party link (agent lane) into the role-agnostic Organisation shape.
export const organisationFromPartyLink = (link: IElectionApplicationLinksData): Organisation => ({
	id: link.partyId,
	name: link.partyName,
	longName: link.partyLongName,
	logo: link.logo,
	generatedLink: link.generatedLink,
	role: 'agent',
});

// Adapts a developmental-partner link (observer lane) into an Organisation.
export const organisationFromPartnerLink = (link: IElectionObserverLinksData): Organisation => ({
	id: link.electionObserverId,
	name: link.organizationName,
	longName: link.accreditationNumber,
	logo: link.logo,
	generatedLink: link.generatedLink,
	role: 'observer',
});
